import { render, staticRenderFns } from "./TrainingView.vue?vue&type=template&id=32151b6c&"
import script from "./TrainingView.vue?vue&type=script&lang=js&"
export * from "./TrainingView.vue?vue&type=script&lang=js&"
import style0 from "./TrainingView.vue?vue&type=style&index=0&id=32151b6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports